import { createApi } from '@reduxjs/toolkit/query/react';

import type {
  ClaimRedeemResponseSchemaType,
  GetClaimRedeemResponseSchemaType,
  RedeemRequestSchemaType,
} from '@/global/schemas/redeem.schema';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const redeemApi = createApi({
  reducerPath: REDUX_SLICE.REDEEM_API,
  tagTypes: ['ClaimRedeemV1', 'ClaimRedeemV2'],
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    claimRedeemV1: builder.mutation<ClaimRedeemResponseSchemaType, RedeemRequestSchemaType>({
      query: data => ({
        method: 'POST',
        path: `v1/projects/${data.nft}/wallets/${data.address}/redeems`,
        data,
        version: 'v1',
      }),
      transformResponse: (returnValue: GetClaimRedeemResponseSchemaType) => returnValue.data,
      invalidatesTags: (_result, _error) => [{ type: 'ClaimRedeemV1' }],
    }),
    claimRedeemV2: builder.mutation<ClaimRedeemResponseSchemaType, RedeemRequestSchemaType>({
      query: data => ({
        method: 'POST',
        path: `v1/projects/${data.nft}/redeems`,
        headers: {
          'x-offchain-address': data.address,
        },
      }),
      transformResponse: (returnValue: GetClaimRedeemResponseSchemaType) => returnValue.data,
      invalidatesTags: (_result, _error) => [{ type: 'ClaimRedeemV2' }],
    }),
  }),
});

export const { useClaimRedeemV1Mutation, useClaimRedeemV2Mutation } = redeemApi;
